import React, { Component } from 'react';
import '../assets/googleradio.css';
import { cx } from '@emotion/css';
import * as styles from './newQuestionBox.style';
import { title } from './questionWithTextFeild.style';
import QuizIndicator from './QuizIndicator';
import withQuizPic from './hoc/withQuizPic';



class ImagewithRadio extends Component {
  constructor(props) {
    super(props);

    this.state = {
      answer: '',
      quizPic: this.props.getRandomImage(1),
    };
    this.handleRadioChange = this.handleRadioChange.bind(this);

  }

  handleRadioChange(event) {
    // set the new value of checked radion button to state using setState function which is async funtion
    this.setState({
      answer: event.target.value,
    });
  }

  selectedanswer = (answer, id) => {
    this.props.selected(answer, id);
  };

  componentDidMount() {
    this.setState({
      answer: this.props.selectedanswer,
      quizPic: this.props.getRandomImage(this.props.questionnumber),
    });
  }

  render() {

    return (
      <div className={cx(styles.multiChoice)}>
        <div className="leftpanel">
          <h2 className={cx(title)}>
            <span>Q{this.props.questionnumber}/</span>
            {this.props.questionCount}
          </h2>

          <img className={cx(styles.imgPoster)} src={this.props.imageurl} />
          <div className="s-title">{this.props.question}</div>
          <QuizIndicator
            className="mb-0"
            questionCount={this.props.questionCount}
            questionnumber={this.props.questionnumber}
          />
        </div>
        <div className="rightpanel">
          <p className="s-title">Select Answer Below </p>
          {this.props.answer.map((text, index) => (
            <label className={cx(styles.input)} key={index}>
              <div id={this.props.id + index}>
                <input
                  type="radio"
                  key={this.props.id + index}
                  value={text}
                  name={this.props.id}
                  checked={this.state.answer === text}
                  className="radiobutton"
                  //label = {text}
                  //id = "radio-1"
                  // style={{height:'20px', width:'20px', background-color: '#ffa500'}}
                  onChange={this.handleRadioChange}
                  onClick={() => {
                    //  this.selectedanswer(text,this.props.id);
                    this.props.selected(text, this.props.id);
                  }}
                />

                {/* {this.props.category == 'Flags'? <h2>{" " + text}</h2> : " "+<h4>{" " + text}</h4>} */}

                {this.props.category === 'Flags' ? (
                  <div className="flags">{' ' + text}</div>
                ) : (
                  <div className="">{'  ' + text}</div>
                )}
              </div>
            </label>
          ))}
          <div className="btn-group">{this.props.controlButtons}</div>
        </div>

        {/* <div className="row">
                <div className="col-6">
                    <div className="row">
                        {
                            this.props.answer.map((text, index) => (
                                <div className="col-6" key={index}>
                                    <StatusCard
                                        icon=""
                                        count="2"
                                        title={text}
                                    />
                                </div>
                            ))
                        }
                    </div>
                </div>
                </div> */}
      </div>
    );
  }
}

export default withQuizPic(ImagewithRadio);
